export type ApplicationConfiguration = {
  [key: string]: string | number | string[];
};

export default async (): Promise<ApplicationConfiguration> => {
  const response = await fetch('/config/config.json');
  const response1 = await response.json();
  return response1.portal || {};
};
